import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ArticleIcon from '@mui/icons-material/Article';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import {Link, useNavigate, useParams} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import SummarizeIcon from "@mui/icons-material/Summarize";

const SECTIONS = [
    {type: 'biznes_reja',        labelKey: 'section_biznes_reja',        Icon: ArticleIcon},
    {type: 'kuzgi_qishki',       labelKey: 'section_kuzgi_qishki',       Icon: AcUnitIcon},
    {type: 'mehnat_muhofazasi',  labelKey: 'section_mehnat_muhofazasi',  Icon: HealthAndSafetyIcon},
    {type: 'yongin_xavfsizligi', labelKey: 'section_yongin_xavfsizligi', Icon: WhatshotIcon},
    {type: 'inventarizatsiya',   labelKey: 'section_inventarizatsiya',   Icon: InventoryIcon},
]

function Card({to, Icon, label}) {
    return (
        <div className="col-lg-3">
            <Link to={to}>
                <div className="card">
                    <div className="card-header"><Icon className={'icon-card'}/></div>
                    <div className="card-body">
                        <h3 className={'text-center mb-0 text-uppercase'}>{label}</h3>
                    </div>
                </div>
            </Link>
        </div>
    )
}

// /main/        → admin umumiy ko'rinish (o'z ma'lumotlari)
// /main/:id     → admin biror tashkilotni ko'rmoqda

function Main() {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const [regionId, setRegionId] = useState(false)

    useEffect(() => { setRegionId(params.id || false) }, [params.id])

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                            {t('back')}
                        </Button>
                        <div className="row">
                            {/* Hujjatlar */}
                            <Card
                                to={regionId ? '/documents/' + regionId : '/documents/'}
                                Icon={FilePresentIcon}
                                label={t('required_documents')}
                            />
                            {/* Muammolar */}
                            <Card
                                to={regionId ? '/problems/' + regionId : '/problems/'}
                                Icon={SyncProblemIcon}
                                label={t('problems')}
                            />
                            {/* Ishchilar */}
                            <Card
                                to={regionId ? '/workers/' + regionId : '/workers/'}
                                Icon={FolderSharedIcon}
                                label={t('workers')}
                            />
                            {/* Hisobotlar */}
                            <Card
                                to={regionId ? '/reports/' + regionId : '/reports/'}
                                Icon={SummarizeIcon}
                                label={t('reports')}
                            />
                            {/* Mahsulotlar bazasi */}
                            <Card
                                to={regionId ? '/mahsulotlar/' + regionId : '/mahsulotlar/'}
                                Icon={ShoppingBagIcon}
                                label={t('mahsulotlar')}
                            />
                            {/* 5 ta qo'shimcha bo'lim */}
                            {SECTIONS.map(({type, labelKey, Icon}) => (
                                <Card
                                    key={type}
                                    to={regionId ? `/sections/${type}/${regionId}` : `/sections/${type}/`}
                                    Icon={Icon}
                                    label={t(labelKey)}
                                />
                            ))}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default Main;
